<button type="button" class="btn {{ customClass }} d-flex align-items-center" (click)="actionSelected()">
  @if (icon != '' && !showSpinner) {
    <i [class]="icon"></i>
  }
  @if (label != '') {
     <span [class]="showSpinner ? 'mr-2' : ''"> {{ label }}</span>
  }
  @if (showSpinner) {
    <i [class]="spinnerIcon"></i>
  }
</button>
